<template>
  <div class="whole-dta">
    <!-- Show empty state if no Amazon connection -->
    <EmptyDashboardState v-if="!hasAmazonConnection" />

    <!-- Show data syncing message if connected but data not ready -->
    <div class="dataunavailable q-mx-xl q-mt-xl" style="justify-content:center;align-items: center;display:flex;"
      v-if="hasAmazonConnection && dataUnavailable">
      <h5 style="color:red;font-weight: bold;">Your account is connected successfully and will take upto 24 hours to sync
        the data</h5>
    </div>
    <div class="wholeScreen q-ml-md q-mr-md q-mt-xl" id="screenshot" v-else-if="hasAmazonConnection && !dataUnavailable">
      <div class="left-side" :style="{ width: $notificationOn.label == '123' ? '50%' : '100' }">
        <div class="row-1 row  ">
          <div class="col-8 q-mr-sm">
            <div class="row boxes">
              <!-- <div class="col-2.6 q-mr-sm">
                <p>Time Period</p>
              </div> -->
              <div class="col-2.6 q-mr-sm">
                <p>Time Period</p>
                <q-btn-dropdown class="dropdown-1" :label="timePeriodDisplay" style="color: black;font-size:15px;">
                  <q-list>
                    <q-item clickable v-for="item in timePeriodList" :key="item" v-close-popup @click="timePeriod(item)">
                      <q-item-section>
                        <q-item-label @click="trackdate(item)">{{ item }}</q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </q-btn-dropdown>
              </div>
              <div class="dateDropDown col-3" style="align-items: flex-end!important; display:flex!important;"
                @click="datedropdown">
                <q-input filled v-model="dateValuecalendar" placeholder='Pick a date range'
                  style="background-color: white !important;">
                  <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy cover transition-show="scale" transition-hide="scale" ref="qStartDateProxy">
                        <q-date v-model="dateRange" ref="myQDate" :options="optionsFn" range
                          @input="closeStartDateCalendar">
                        </q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
            </div>
          </div>
          <div class="column-2 col">
            <div class="col">
              <div class="col-2.1">
                <p>Compared to</p>
              </div>
              <div class="col">
                <q-btn-dropdown class="dropdown-1 " :label="compareTimePeriod" style="color: black;font-size:15px;">
                  <q-list>
                    <!-- <q-item clickable v-for="item in compareTimePeriodList" :key="item" v-close-popup
                  @click="compareTimePeriod()">
                  <q-item-section>
                    <q-item-label>{{ item }}</q-item-label>
                  </q-item-section>
                </q-item> -->
                  </q-list>
                </q-btn-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="row boxes q-mt-sm ">
          <div class="col box" :class="{ 'active-button': activeButton === 'total_sales' }">
            <i class="icon fa fa-info-circle" aria-hidden="true">
              <q-tooltip>
                <P class='paragraph'>Total sales for Amazon sellers represent the overall revenue generated from their
                  products sale on the
                  Amazon platform. It doesn't include refunds, returns, and cancellations.</P>
              </q-tooltip>
            </i>
            <button class="buttonBox" @click="graphData('total_sales')">
              <p class="box-title">Total Sales <br> <span class="box-value"><!--&#x20B9--> {{
                grossSales.toLocaleString(options)
              }}</span></p>
              <p class="difference"><span :style="salesDifferencePercentage >= 0
                    ? 'color:#00FF00;brightness(2);font-weight:bold;font-size:20px'
                    : 'color:#FF0000;brightness(2);font-weight:bold;font-size:20px'
                  ">{{ salesDifferencePercentage >= 0 ? "\u2191" : "\u2193" }}</span>{{ absoluteSalesDifferencePercentage
    }} %
                <font-awesome-icon icon="fa-solid fa-line-chart" class="icons q-ml-sm" />
              </p>
            </button>
          </div>
          <div class="col box" :class="{ 'active-button': activeButton === 'total_order' }">
            <i class="icon fa fa-info-circle" aria-hidden="true">
              <q-tooltip>
                <P class='paragraph'>Total orders for Amazon sellers refer to the total number of purchases made by
                  customers for their
                  products on the Amazon platform within a specific period</P>
              </q-tooltip>
            </i>
            <button class="buttonBox" @click="graphData('total_order')">
              <p class="box-title">Total Orders</p>
              <p class="box-value">{{ totalOrder }} </p>
              <p class="difference"><span :style="totalOrderDifference >= 0
                ? 'color:#00FF00;brightness(2);font-weight:bold;font-size:20px'
                : 'color:#FF0000;brightness(2);font-weight:bold;font-size:20px'
                ">{{ totalOrderDifference >= 0 ? "\u2191" : "\u2193" }}</span> {{ absoluteTotalOrderDifference }}
                <font-awesome-icon icon="fa-solid fa-line-chart" class="icons q-ml-sm" />
              </p>
            </button>
          </div>
          <div class="col box" :class="{ 'active-button': activeButton === 'total_unit' }">
            <i class="icon fa fa-info-circle" aria-hidden="true">
              <q-tooltip>
                <P class='paragraph'>Total units sold for Amazon sellers refer to the total number of units sold on the
                  Amazon platform
                  within a specific period.</P>
              </q-tooltip>
            </i>
            <button class="buttonBox" @click="graphData('total_unit')">
              <p class="box-title" style="text-align:left">Total Units</p>
              <p class="box-value">{{ totalUnit }} </p>
              <p class="difference"> <span :style="totalUnitDifference >= 0
                ? 'color:#00FF00;brightness(2);font-weight:bold;font-size:20px'
                : 'color:#FF0000;brightness(2);font-weight:bold;font-size:20px'
                ">{{ totalUnitDifference >= 0 ? "\u2191" : "\u2193" }}</span> {{ absoluteTotalUnitDifference }}
                <font-awesome-icon icon="fa-solid fa-line-chart" class="icons q-ml-sm" />
              </p>
            </button>
          </div>
          <div class="col box">
            <i class="icon fa fa-info-circle" aria-hidden="true">
              <q-tooltip>
                <P class='paragraph'>Average of total sales for a certain period for Amazon seller.</P>
              </q-tooltip>
            </i>
            <p class="box-title" style="padding-top:8px">Avg. Sales per day</p>
            <p class="box-value"> <!--&#x20B9--> {{ avgSalesPerDay.toLocaleString(options) }}</p>
            <p class="difference"><span :style="avgSalesPerDayDifference >= 0
              ? 'color:#00FF00;brightness(2);font-weight:bold;font-size:20px'
              : 'color:#FF0000;brightness(2);font-weight:bold;font-size:20px'
              ">{{ avgSalesPerDayDifference >= 0 ? "\u2191" : "\u2193" }}</span> <!--&#x20B9--> {{
    absoluteAvgSalesPerDayDifference }}</p>
          </div>
          <div class="col box">
            <i class="icon fa fa-info-circle" aria-hidden="true">
              <q-tooltip>
                <P class='paragraph'>Average of total orders for a certain period for Amazon seller.</P>
              </q-tooltip>
            </i>
            <p class="box-title" style="padding-top:8px">Avg. Orders per day</p>
            <p class="box-value">{{ avgOrdersPerDay.toFixed(2) }}</p>
            <p class="difference"><span :style="avgOrdersPerDayDifference >= 0
              ? 'color:#00FF00;brightness(2);font-weight:bold;font-size:20px'
              : 'color:#FF0000;brightness(2);font-weight:bold;font-size:20px'
              ">{{ avgOrdersPerDayDifference >= 0 ? "\u2191" : "\u2193" }}</span> {{ absoluteAvgOrdersPerDayDifference
  }}</p>
          </div>
          <div class="col box">
            <i class="icon fa fa-info-circle" aria-hidden="true">
              <q-tooltip>
                <P class='paragraph'>It is a metric that measures the percentage of advertising spent in relation to the
                  total revenue
                  generated from ad-driven sales and organic sales together</P>
              </q-tooltip>
            </i>
            <p class="box-title" style="padding-top:8px">TACoS</p>
            <p class="box-value"> {{ tacos }}</p>
            <p class="difference"><span :style="tacosDifference >= 0
              ? 'color:#00FF00;brightness(2);font-weight:bold;font-size:20px' : 'color:#FF0000;brightness(2);font-weight:bold;font-size:20px'
              ">{{ tacosDifference >= 0 ? "\u2191" : "\u2193" }}</span>{{ absoluteTacosDifference }}</p>
          </div>
        </div>
        <div class="row boxes ">
          <div class="col box" :class="{ 'active-button': activeButton === 'ad_sales' }">
            <i class="icon fa fa-info-circle" aria-hidden="true">
              <q-tooltip>
                <P class='paragraph'>The amount of revenue generated from ad-driven sales.</P>
              </q-tooltip>
            </i>
            <button class="buttonBox" @click="graphData('ad_sales')">
              <p class="box-title">Ad Sales <br><span class="box-value"> <!--&#x20B9--> {{ adSale.toLocaleString(options)
              }}</span>
              </p>
              <p class="difference"><span :style="adSaleDifferencePercentage >= 0
                  ? 'color:#00FF00;brightness(2);font-weight:bold;font-size:20px'
                  : 'color:#FF0000;brightness(2);font-weight:bold;font-size:20px'
                ">{{ adSaleDifferencePercentage >= 0 ? "\u2191" : "\u2193" }}</span> {{
    absoluteAdSaleDifferencePercentage }}%
                <font-awesome-icon icon="fa-solid fa-line-chart" class="icons q-ml-sm" />
              </p>
            </button>
          </div>
          <div class="col box" :class="{ 'active-button': activeButton === 'ad_spent' }">
            <i class="icon fa fa-info-circle" aria-hidden="true">
              <q-tooltip>
                <P class='paragraph'>The amount of advertising spent for a certain period.</P>
              </q-tooltip>
            </i>
            <button class="buttonBox" @click="graphData('ad_spent')">
              <p class="box-title">Ad Spent <br> <span class="box-value"> <!--&#x20B9-->{{ adSpent.toLocaleString(options)
              }}</span></p>
              <p class="difference"> <span :style="adSpentDifferencePercentage >= 0
                  ? 'color:#FF0000;brightness(2);font-weight:bold;font-size:20px' : 'color:#00FF00;brightness(2);font-weight:bold;font-size:20px'
                ">{{ adSpentDifferencePercentage >= 0 ? "\u2191" : "\u2193" }}</span> {{
    absoluteAdSpentDifferencePercentage }} %
                <font-awesome-icon icon="fa-solid fa-line-chart" class="icons q-ml-sm" />
              </p>
            </button>
          </div>
          <div class="col box" :class="{ 'active-button': activeButton === 'ad_order' }">
            <i class="icon fa fa-info-circle" aria-hidden="true">
              <q-tooltip>
                <P class='paragraph'>No of purchases generated from ad-driven sales.</P>
              </q-tooltip>
            </i>
            <button class="buttonBox" @click="graphData('ad_order')">
              <p class="box-title">Ad Sales Volume (Orders)</p>
              <p class="box-value"> {{ adsalesOrders }}</p>
              <p class="difference"><span :style="adSalesOrdersDifference >= 0
                ? 'color:#00FF00;brightness(2);font-weight:bold;font-size:20px'
                : 'color:#FF0000;brightness(2);font-weight:bold;font-size:20px'
                ">{{ adSalesOrdersDifference >= 0 ? "\u2191" : "\u2193" }}</span> {{ absoluteAdSalesOrdersDifference }}
                <font-awesome-icon icon="fa-solid fa-line-chart" class="icons q-ml-sm" />
              </p>
            </button>
          </div>
          <div class="col box" :class="{ 'active-button': activeButton === 'ad_units' }">
            <i class="icon fa fa-info-circle" aria-hidden="true">
              <q-tooltip>
                <P class='paragraph'> No of units sold from ad-driven sales.</P>
              </q-tooltip>
            </i>
            <button class="buttonBox" @click="graphData('ad_units')">
              <p class="box-title">Ad Sales Units <br> <span class="box-value">{{ adsalesUnits }} </span></p>
              <p class="difference"><span :style="adSalesUnitsDifference >= 0
                ? 'color:#00FF00;brightness(2);font-weight:bold;font-size:20px'
                : 'color:#FF0000;brightness(2);font-weight:bold;font-size:20px'
                ">{{ adSalesUnitsDifference >= 0 ? "\u2191" : "\u2193" }}</span> {{ absoluteAdSalesUnitsDifference
  }}<font-awesome-icon icon="fa-solid fa-line-chart" class="icons q-ml-sm" /></p>
            </button>
          </div>
          <div class="col box">
            <i class="icon fa fa-info-circle" aria-hidden="true">
              <q-tooltip>
                <P class='paragraph'>(Return on Advertising Spend) for Amazon sellers is a performance metric that
                  represents the amount of
                  revenue generated for each rupee spent on advertising.</P>
              </q-tooltip>
            </i>
            <p class="box-title q-mt-md">ROAS </p>
            <p class="box-value"> {{ roas }}</p>
            <p class="difference"> <span :style="roasDifference >= 0
              ? 'color:#00FF00;brightness(2);font-weight:bold;font-size:20px'
              : 'color:#FF0000;brightness(2);font-weight:bold;font-size:20px'
              ">{{ roasDifference >= 0 ? "\u2191" : "\u2193" }}</span>{{ absoluteRoasDifference }}</p>
          </div>
          <div class="col box">
            <i class="icon fa fa-info-circle" aria-hidden="true">
              <q-tooltip>
                <P class='paragraph'>It is a metric that measures the percentage of advertising spent in relation to the
                  total revenue generated from ad-driven sales. A lower ACOS indicates more efficient advertising spend.
                </P>
              </q-tooltip>
            </i>
            <p class="box-title" style="padding-top:8px">ACoS</p>
            <p class="box-value">{{ acos }}</p>
            <p class="difference"><span :style="acosDifference >= 0
              ? 'color:#FF0000;brightness(2);font-weight:bold;font-size:20px' : 'color:#00FF00;brightness(2);font-weight:bold;font-size:20px'
              ">{{ acosDifference >= 0 ? "\u2191" : "\u2193" }}</span>{{ absoluteAcosDifference }}</p>
          </div>
        </div>
        <div class="disclaimer">
          Disclaimer: 1. At present the data refresh done twice in a day. 2. Sales Attribution can be
          updated up to 7days from the date of click for the advertisement sales.
        </div>
        <div>
          <q-btn class="download-report" label="Download Snapshot" @click="generatePDF"></q-btn>
        </div>
        <div class="apexchart-1 q-mt-lg">
          <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
        </div>
      </div>
      <div class="recommendation-panel q-ml-md " v-if="$notificationOn.label == '123'">
        <font-awesome-icon class="close-icon" icon="fa-solid fa-chevron-circle-right" @click="$notificationOn.label = ''"
          v-if="$notificationOn.label == '123'" />
        <div>
          <p class="recommendation">Recommendations</p>
          <div class="recommendation-box q-mt-md" v-for="v in headers.length" :key="v">
            <div class="recommendation-title q-ml-sm q-mb-sm">
              <p>{{ title[v - 1] }}</p>
            </div>
            <div class="recommendation-description">
              <p>{{ description[v - 1] }}</p>
            </div>
            <div class="row q-mx-sm q-my-sm ">
              <div class="col-5">
                <p class="take-action">Take Action Now</p>
              </div>
              <div class="col">
                <p class="delete">Delete this Recommendation</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EmptyDashboardState from '../components/EmptyDashboardState.vue';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { GoogleSpreadsheet } from 'google-spreadsheet'
import { ref } from 'vue'
export default {
  components: {
    EmptyDashboardState
  },
  setup() {
    //date range in calender.Other dates will be blocked
    const dateRange = ref({ from: '', to: '' })
    return {
      dateRange,
      optionsFn(dateRange) {
        return dateRange >= this.min_date && dateRange <= this.max_date
      },
    }
  },
  data() {
    return {
      rows: [],
      isAuthenticated: false,
      preview: false,
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      flag: 0,
      timePeriodList: ["Last 1 day", "Last 7 days", "Last 30 days"],
      timePeriodDisplay: "Last 30 days",
      compareTimePeriodDisplay: "Last month",
      dateValuecalendar: '',
      yesterday: '',
      grossSales: 0,
      totalOrder: 0,
      max_date: "",
      min_date: "",
      totalUnit: 0,
      adSale: 0,
      adSpent: 0,
      salesDifferencePercentage: 0,
      absoluteSalesDifferencePercentage: 0,
      totalOrderDifference: 0,
      absoluteTotalOrderDifference: 0,
      totalUnitDifference: 0,
      absoluteTotalUnitDifference: 0,
      adSaleDifferencePercentage: 0,
      absoluteAdSaleDifferencePercentage: 0,
      adSpentDifferencePercentage: 0,
      absoluteAdSpentDifferencePercentage: 0,
      avgSalesPerDay: 0,
      avgSalesPerDayDifference: 0,
      absoluteAvgSalesPerDayDifference: 0,
      avgOrdersPerDay: 0,
      avgOrdersPerDayDifference: 0,
      absoluteAvgOrdersPerDayDifference: 0,
      adsalesOrders: 0,
      adSalesOrdersDifference: 0,
      absoluteAdSalesOrdersDifference: 0,
      adsalesUnits: 0,
      adSalesUnitsDifference: 0,
      absoluteAdSalesUnitsDifference: 0,
      acos: 0,
      acosDifference: 0,
      absoluteAcosDifference: 0,
      tacos: 0,
      tacosDifference: 0,
      absoluteTacosDifference: 0,
      headers: [],
      tableData1: [],
      options: null,
      headerValues: [],
      title: [],
      description: [],
      dataGraph: [],
      dateSpend: [],
      roasDifference: 0,
      absoluteRoasDifference: 0,
      dataUnavailable: false,
      hasAmazonConnection: true,
      roas: 0,
      series: [{
        name: "spent",
        data: this.dataGraph,
      }],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          text: 'Performance over time',
          align: 'left'
        },
        // grid: {
        //   row: {
        //     colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        //     opacity: 0.5
        //   },
        // },
        xaxis: {
          categories: this.dateSpend,
        }
      },
      activeButton: null,
      //sorders
    }
  },
  mounted() {
    this.$mixpanel.track_pageview({ "page": "HomeDashboard" });
    this.$q.loading.show({
      message: "Authenticating please wait..",
    });
    if (this.$cookies.isKey("login_authentication")) {
      let encryptedText = this.$cookies.get("login_authentication");
      const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
      if (decryptedText == "authenticated") {
        this.$store.dispatch("setPathName", "/homedashboard");
        this.$q.loading.hide();
        this.isAuthenticated = true;
      }
      else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else if (this.$cookies.isKey("login_authentication1")) {
      let encryptedText = this.$cookies.get("login_authentication1");
      const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
      if (decryptedText == "authenticated") {
        this.$store.dispatch("setPathName", "/homedashboard");
        this.$q.loading.hide();
        this.isAuthenticated = true;
      }
      else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else if (this.$cookies.isKey("login_authentication2")) {
      let encryptedText = this.$cookies.get("login_authentication2");
      const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
      if (decryptedText == "authenticated") {
        this.$store.dispatch("setPathName", "/amazonadoptimization/automationrules");
        this.$q.loading.hide();
        this.isAuthenticated = true;
      }
      else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else {
      this.$q.loading.hide();
      this.$router.push({
        name: "NotAuthenticated",
      });
      return;
    }
    this.$q.loading.show({
      message: "Loading...",
    })
    var today = new Date();
    let yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    this.max_date = yesterday.getFullYear() + '/' + (yesterday.getMonth() + 1).toString().padStart(2, '0') + '/' + yesterday.getDate().toString().padStart(2, '0');
    yesterday.setDate(today.getDate() - 60);
    this.min_date = yesterday.getFullYear() + '/' + (yesterday.getMonth() + 1).toString().padStart(2, '0') + '/' + yesterday.getDate().toString().padStart(2, '0');
  },

  computed: {
    compareTimePeriod() {
      if (this.timePeriodDisplay === 'Last 30 days') {
        this.dateValue = 'Monthly'
        this.duration = 'month'
        return 'Previous 30 days'
      }
      else if (this.timePeriodDisplay === 'Last 7 days') {
        this.dateValue = 'Weekly'
        this.duration = 'week'
        return 'Previous 7 days'
      }
      else if (this.timePeriodDisplay === 'Last 1 day') {
        this.dateValue = 'Daily'
        this.duration = 'day'
        return 'Previous 1 day'
      }
      else {
        return ''
      }
    },
    rows: function () {
      return Array.from(Array(10).keys()).map(x => x + 1);
    }
  },
  async created() {
    const doc = new GoogleSpreadsheet('1ow58TDisXi3bBtNSN1YW0S6oGIR1cbzGVQdDnlA3uF0')
    await doc.useApiKey('AIzaSyCAhd62sazqSCyyAqn_wL4UB2AjciHRIpI')
    await doc.loadInfo()
    var sheet = doc.sheetsByIndex[0]
    await sheet.loadCells('A1:C1');
    var rows = await sheet.getRows()
    this.rows = rows
    let products = this.rows.filter((items) => {
      if (items.Org_name === undefined || items.Org_name === null) {
        return false;
      }
      return items.Org_name.toLowerCase() === (this.$orgName?.label || '').toLowerCase()
    })
    let filteredData = products.map((item) =>
      item.Org_name
    );
    this.headers = filteredData;
    this.title = products.map((item) =>
      item.title
    );
    this.description = products.map((item) =>
      item.description
    );
    this.$notificationOn.label = '';
    this.timePeriod('Last 30 days')
  },
  methods: {
    // trackPageDuration() {
    //   const endTime = new Date();
    //   const duration = (endTime - this.startTime) / 1000; // Convert milliseconds to seconds
    //   this.$mixpanel.track('Page View - HomeDashboard', {
    //     page: "HomeDashboard",
    //     duration_seconds:` User spends ${duration} seconds`
    //   });
    // },
    datedropdown() {
      const endTime = new Date();
      const duration = (endTime - this.startTime) / 1000;

      const now = new Date();
      const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
      const istTime = now.toLocaleString('en-US', options);
      this.$mixpanel.track('HomeDashboard: Date Range', {
        info: `user Selected the DateRange `,
        Time: istTime,
        Date: new Date().toDateString(),
      });

    },
    generatePDF() {
      const now = new Date();
      const options1 = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
      const istTime = now.toLocaleString('en-US', options1);
      this.$mixpanel.track('HomeDashboard: Download Report', {
        info: 'user Downloaded the report',
        Time: istTime,
        Date: new Date().toDateString(),
      });
      const element = document.getElementById('screenshot');
      const scale = window.devicePixelRatio;
      const options = {
        scale: scale,
        useCROS: true,
      };
      html2canvas(element, options).then(canvas => {
        const pdf = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
        });
        const imgData = canvas.toDataURL('image/png', 1.0);
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const ratio = imgProps.height / imgProps.width;
        const imgWidth = pdfWidth;
        const imgHeight = pdfWidth * ratio;
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
        pdf.save("Report.pdf");
        // var formData1 = new FormData();
        // formData1.append('file');
      });
    },
    closeStartDateCalendar() {
      this.$refs.qStartDateProxy.hide();
      this.dateValuecalendar = this.dateRange.from + ' - ' + this.dateRange.to
      this.timePeriodDisplay = '';
      this.dashboardBackendCall()

    },
    optionsFn(dateRange) {
      return dateRange >= this.min_date && dateRange <= this.max_date
    },
    timePeriod(timePeriod) {
      const now = new Date();
      const options = { timeZone: 'Asia/Kolkata' };
      const istTime = now.toLocaleString('en-US', options);
      this.$mixpanel.track('Selecting TimePeriod', {
        Info: `user selected ${timePeriod}`,
        Date_Time: istTime


      });
      this.options = {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      };
      this.dateValuecalendar = ""
      this.timePeriodDisplay = timePeriod;
      this.dashboardBackendCall()
    },
    dashboardBackendCall() {
      this.$q.loading.show({});
      var productsURL = this.api_url + "/dashboard/get_homepagedashboard_data";
      this.$http
        .post(productsURL, this.dashboardBackend())
        .then((response) => {
          if (response.data === null) {
            this.dataUnavailable = true;
            this.$q.loading.hide()
          }
          else {
            this.dataUnavailable = false;
            var dashboardData = response.data;
            this.grossSales = dashboardData.totalSale_current;
            this.totalOrder = dashboardData.totalOrders_current;
            this.totalUnit = dashboardData.totalUnit_current;
            this.adSale = dashboardData.ad_sale;
            this.adSpent = dashboardData.ad_cost;
            this.avgSalesPerDay = dashboardData.avgSales_perday;
            this.avgOrdersPerDay = dashboardData.avg_orders_per_day;
            this.adsalesOrders = dashboardData.ad_sales_order;
            this.adsalesUnits = dashboardData.ad_sales_units;
            this.acos = dashboardData.acos;
            this.tacos = dashboardData.tacos;
            //sale
            var salesDifference = dashboardData.totalSale_current - dashboardData.totalSale_old;
            this.salesDifferencePercentage = ((salesDifference / dashboardData.totalSale_old) * 100).toFixed(2);
            this.absoluteSalesDifferencePercentage = Math.abs(this.salesDifferencePercentage);
            //totalorder
            this.totalOrderDifference = dashboardData.totalOrders_current - dashboardData.totalOrders_old;
            this.absoluteTotalOrderDifference = Math.abs(this.totalOrderDifference);
            //total unit
            this.totalUnitDifference = dashboardData.totalUnit_current - dashboardData.totalUnit_old;
            this.absoluteTotalUnitDifference = Math.abs(this.totalUnitDifference);
            //adsale
            var adSaleDifference = dashboardData.ad_sale - dashboardData.ad_sale_old;
            if (dashboardData.ad_sale_old == 0) {
              this.adSaleDifferencePercentage = 0;
            }
            else {
              this.adSaleDifferencePercentage = ((adSaleDifference / dashboardData.ad_sale_old) * 100).toFixed(2);
            }
            this.absoluteAdSaleDifferencePercentage = Math.abs(this.adSaleDifferencePercentage);
            //adspent
            var adSpentDifference = dashboardData.ad_cost - dashboardData.ad_cost_old;
            this.adSpentDifferencePercentage = ((adSpentDifference / dashboardData.ad_cost_old) * 100).toFixed(2);
            this.absoluteAdSpentDifferencePercentage = (Math.abs(this.adSpentDifferencePercentage))
            this.$q.loading.hide();
            //adsalesorders
            this.adSalesOrdersDifference = (dashboardData.ad_sales_order - dashboardData.ad_sales_order_old).toFixed(2);
            this.absoluteAdSalesOrdersDifference = Math.abs(this.adSalesOrdersDifference);
            //adsalesunit
            this.adSalesUnitsDifference = (dashboardData.ad_sales_units - dashboardData.ad_sales_units_old).toFixed(2);
            this.absoluteAdSalesUnitsDifference = Math.abs(this.adSalesUnitsDifference);
            //averagesalesperday
            this.avgSalesPerDayDifference = (dashboardData.avgSales_perday - dashboardData.avgSales_perday_old).toFixed(2);
            this.absoluteAvgSalesPerDayDifference = Math.abs(this.avgSalesPerDayDifference);
            //averageorderssperday
            this.avgOrdersPerDayDifference = (dashboardData.avg_orders_per_day - dashboardData.avg_orders_per_day_old).toFixed(2);
            this.absoluteAvgOrdersPerDayDifference = Math.abs(this.avgOrdersPerDayDifference);
            //acos
            if (dashboardData.acos == null || dashboardData.acos_old == null) {
              this.acos = "-";
              this.acosDifference = "-";
              this.absoluteAcosDifference = "-";
            }
            else {
              this.acos = dashboardData.acos;
              this.acosDifference = (dashboardData.acos - dashboardData.acos_old).toFixed(2);
              this.absoluteAcosDifference = Math.abs(this.acosDifference);
            }
            //tacos
            this.tacosDifference = (dashboardData.tacos - dashboardData.tacos_old).toFixed(2);
            this.absoluteTacosDifference = Math.abs(this.tacosDifference);
            //
            this.roas = dashboardData.roas
            if (this.roas == null || dashboardData.roas_old == null) {
              this.roas = "-";
              this.roasDifference = "-";
              this.absoluteRoasDifference = "-";
            }
            else {
              this.roas = (dashboardData.roas).toFixed(2);
              this.roasDifference = (dashboardData.roas - dashboardData.roas_old).toFixed(2);
              this.absoluteRoasDifference = Math.abs(this.roasDifference);
            }
            this.graphData('total_sales')
          }
        });
    },
    dashboardBackend(item) {
      var today = new Date();
      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      this.yesterday = yesterday.getFullYear() + '-' + (yesterday.getMonth() + 1).toString().padStart(2, '0') + '-' + yesterday.getDate().toString().padStart(2, '0');
      if (this.timePeriodDisplay == "Last 1 day") {
        this.startDate = this.yesterday
      }
      else if (this.timePeriodDisplay == "Last 7 days") {
        let yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 8);
        this.startDate = yesterday.getFullYear() + '-' + (yesterday.getMonth() + 1).toString().padStart(2, '0') + '-' + yesterday.getDate().toString().padStart(2, '0');
      }
      else if (this.timePeriodDisplay == "Last 30 days") {
        let yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 31);
        this.startDate = yesterday.getFullYear() + '-' + (yesterday.getMonth() + 1).toString().padStart(2, '0') + '-' + yesterday.getDate().toString().padStart(2, '0');
      }
      else {
        this.startDate = this.dateRange.from.replaceAll("/", "-");
        this.yesterday = this.dateRange.to.replaceAll("/", "-");
      }
      return [
        {
          start_date: this.startDate,
          end_date: this.yesterday,
          org_id: (this.$org_id.label).toString(),
        },
      ]
    },
    graphBackend(item) {
      return [
        {
          start_date: this.startDate,
          end_date: this.yesterday,
          org_id: (this.$org_id.label).toString(),
          data_type: item
        },
      ]
    },
    graphData(item) {
      const now = new Date();
      const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
      const DateandDay = { timeZone: 'Asia/Kolkata', weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      const Seconds = { timeZone: 'Asia/Kolkata', second: 'numeric' };
      const istTime = now.toLocaleString('en-US', options);
      const istDateAndDay = now.toLocaleDateString('en-US', DateandDay);
      const seconds = now.toLocaleTimeString('en-US', Seconds);
      console.log(istDateAndDay);

      this.$mixpanel.track(`HomeDashboard: ${item}`, {
        Path: `User Selected ${item}`,
        UserEmail: localStorage.getItem('email'),
        Time: istTime,
        Date: istDateAndDay,
        TimeSpend: `The user spent ${seconds} seconds on the application.`
      })
      this.$q.loading.show({
      });
      this.activeButton = item;
      this.flag = 1;
      var productsURL = this.api_url + "/dashboard/get_homepage_graph_data";
      this.$http
        .post(productsURL, this.graphBackend(item))
        .then((response) => {
          var data = response.data
          this.data = data
          this.data = data.sort((a, b) => {
            return new Date(a.date) - new Date(b.date);
          });
          this.dateSpend = this.data.map((item) =>
            item.date
          );
          this.dataGraph = this.data.map((item) =>
            item.data.toFixed(2)
          );
          if (item === 'ad_sales') {
            var title = "Ad Sales"
          }
          else if (item === 'ad_spent') {
            var title = "Ad Spent"
          }
          else if (item === 'total_order') {
            var title = "Total Orders"
          }
          else if (item === 'total_unit') {
            var title = "Total Units"
          }
          else if (item === 'ad_order') {
            var title = "Ad Sales Volume"
          }
          else if (item === 'ad_units') {
            var title = "Ad Sales Units"
          }
          else {
            var title = "Total Sales"
          }
          this.series = [{
            name: title,
            data: this.dataGraph,
          }];
          this.chartOptions = {
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'smooth',
              width: 2
            },
            title: {
              text: 'Performance over time',
              align: 'left'
            },
            grid: {
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            yaxis: [{
              title: {
                text: title,
                style: {
                  fontSize: '13px',
                  fontFamily: "'Poppins', sans-serif"
                }
              },
            },
            ],
            xaxis: {
              categories: this.dateSpend,
              title: {
                display: true,
                text: 'Date',
                position: 'bottom',
              }
            }
          };
          this.$q.loading.hide()
        })

      // if(item == 'gross'){
      //   this.series= [{
      //         name: "Desktops",
      //         data: [25,35,45,55],
      //     }];
      // }
      // else  if(item == 'netSale'){
      //   this.series= [{
      //         name: "Desktops",
      //         data: [25,35,45,55],
      //     }];
      // }
      // else  if(item == 'adSale'){
      //   this.series= [{
      //         name: "Desktops",
      //         data: [25,35,45,55],
      //     }];
      // }
      // else  if(item == 'adSpent'){
      //   this.series= [{
      //         name: "Desktops",
      //         data: [25,35,45,55],
      //     }];
      // }
      // else  if(item == 'totalOrder'){
      //   this.series= [{
      //         name: "Desktops",
      //         data: [25,35,45,55],
      //     }];
      // }
      // else  if(item == 'totalUnit'){
      //   this.series= [{
      //         name: "Desktops",
      //         data: [25,35,45,55],
      //     }];
      // }
      // else  if(item == 'adSaleVolume'){
      //   this.series= [{
      //         name: "Desktops",
      //         data: [25,35,45,55],
      //     }];
      // }
      // else  if(item == 'adSaleUnit'){
      //   this.series= [{
      //         name: "Desktops",
      //         data: [25,35,45,55],
      //     }];
      // }
      // else{
      // }
    }
  }
}
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
@import url('https://fonts.googleapis.com/css?family=Lato:wght@500&display=swap');
@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@500&display=swap");

.wholeScreen {
  height: 100%;
  font-family: "Montserrat", sans-serif;
}

.active-button {
  border-left: 3px solid blue;
}

.box {
  padding: 12px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  opacity: 1;
  margin: 10px;
}

.box-title {
  text-align: left;
  font: normal normal normal 13px/20px Poppins;
  letter-spacing: 0px;
  color: #354052;
  opacity: 1;
}

.box-value {
  text-align: left;
  font: normal normal 600 28px/30px Lato;
  letter-spacing: 0px;
  color: #343434;
  opacity: 1;
}

p {
  margin: 0 0 0px !important;
}

.wholeScreen h6 {
  color: #102689;
  font-weight: 500;
  font-weight: bold;
}

.difference {
  font-size: 11px;
  text-align: left;
}

.left-side {
  flex: 100;
  transition: all 0.3s ease-in-out;
  position: relative;
}

.download-report {
  position: absolute;
  right: 1%;
  background: #378CEF 0% 0% no-repeat padding-box;
  opacity: 1;
  color: white;
}

.download-report-hr {
  margin-top: 35px;
}

.wholeScreen {
  display: flex;
  flex-direction: row;
}

.recommendation-panel {
  position: relative;
  flex: 25;
  background: white 0% 0% no-repeat padding-box;
  border-radius: 12px;
  opacity: 1;
  padding: 25px;
  max-height: 100% !important;
  overflow-y: scroll;
}

.close-icon {
  font-size: 25px;
  position: absolute;
  right: 90%;
  top: 0;
}

.recommendation {
  text-align: left;
  font: normal normal bold 23px/27px Raleway;
  letter-spacing: 0px;
  color: #11141A;
  opacity: 1;
}

.recommendation-box {
  background: #FBFAFF 0% 0% no-repeat padding-box;
  border: 1px solid #E6E6E6;
  border-radius: 10px;
  opacity: 1;
}

.recommendation-title {
  text-align: left;
  font: normal normal bold 18px/22px Lato;
  letter-spacing: 0.83px;
  color: #11141A;
  text-transform: capitalize;
  opacity: 1;
  padding: 2px;
}

.recommendation-description {
  background: #FFFFFF 0% 0% no-repeat padding-box !important;
  border-radius: 12px;
  opacity: 1;
  text-align: left;
  font: normal normal normal 13px/14px Lato;
  letter-spacing: 0px;
  color: #354052;
  opacity: 0.8;
  margin: 5px;
  padding: 3px;
}

.take-action {
  text-align: left;
  font: normal normal bold 13px/14px Lato;
  letter-spacing: 0px;
  color: #322A7D;
  opacity: 1;
}

.delete {
  text-align: left;
  font: normal normal bold 12px/14px Lato;
  letter-spacing: 0px;
  color: #FE3D3D;
  opacity: 1;
}

.box button {
  background-color: transparent !important;
  height: 100%;
  width: 100%;
  border: none;
  cursor: pointer;
}

.apexcharts-menu-icon,
.apexcharts-selection-icon {
  display: none;
}

.apexchart-1 {
  width: 100%
}

.box {
  position: relative
}

.icon {
  position: absolute;
  top: 1%;
  right: 0;
  margin-right: 2%;
}

.icon p {
  font-size: 100px !important;
}

.row-1 {
  position: relative;
}

.column-2 {
  position: absolute;
  right: 1%;
}

.paragraph {
  font-size: 12px !important;
  width: 200px;
}

.dateDropDown .q-field--filled .q-field__control {
  padding: 0 12px;
  background: white !important;
  border-radius: 6px !important;
}

/* element.style {
}
<style>
.q-field--filled .q-field__control {
    padding: 0 12px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px 4px 0 0;
}
<style>
.relative-position {
    position: relative;
}
<style>
.no-wrap {
    flex-wrap: nowrap;
}
<style>
.row, .column, .flex {
    display: flex;
    flex-wrap: wrap;
}
<style> */
.dateDropDown .q-field__control {
  color: #027BE3;
  color: var(--q-color-primary);
  height: 39px !important;
  width: 250px !important;
  outline: none;
}

.dateDropDown .q-icon {
  width: 1em !important;
  height: 10px !important;
  flex-shrink: 0;
  letter-spacing: normal;
  text-transform: none;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  text-align: center;
  position: relative;
  box-sizing: content-box;
}

.dateDropDown input:valid {
  background-color: white !important;
  outline: none;
  border-bottom: none !important;
}

.dateDropDown .q-field__marginal {
  height: 23px !important;
  font-size: 24px;
}

.disclaimer {
  color: darkgoldenrod;
}

@media only screen and (max-width: 600px) {
  .boxes {
    display: block;
  }

  .dateDropDown {
    margin-top: 1rem;
  }

  .download-report {
    margin-bottom: 1rem;
  }
}</style>